import { render } from "./SmartCard.vue?vue&type=template&id=5f0c4b4a&scoped=true"
import script from "./SmartCard.vue?vue&type=script&lang=js"
export * from "./SmartCard.vue?vue&type=script&lang=js"

import "./SmartCard.vue?vue&type=style&index=0&id=5f0c4b4a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0c4b4a"]])

export default __exports__